import { render } from "./HeadBar.vue?vue&type=template&id=33638f9a&scoped=true"
const script = {}

import "./HeadBar.vue?vue&type=style&index=0&id=33638f9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33638f9a"]])

export default __exports__